import script from "./ho-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./ho-form.vue?vue&type=script&setup=true&lang=ts"

import "./ho-form.vue?vue&type=style&index=0&id=73df1ade&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73df1ade"]])

export default __exports__